import { render, staticRenderFns } from "./JCheckbox.vue?vue&type=template&id=ae97dc28"
import script from "./JCheckbox.vue?vue&type=script&lang=js"
export * from "./JCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae97dc28')) {
      api.createRecord('ae97dc28', component.options)
    } else {
      api.reload('ae97dc28', component.options)
    }
    module.hot.accept("./JCheckbox.vue?vue&type=template&id=ae97dc28", function () {
      api.rerender('ae97dc28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JCheckbox.vue"
export default component.exports